
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { RouterModule } from '@angular/router'
import { Core } from '../core/core'
import {
  SE_POSITIONING_SERVICE_MODULE_BUNDLE,
} from '../positioning-service/positioning-service.module'

import { SeMenuService } from './menu.service'
import { SeMenuComponent } from './menu.component'
import { SeMenuItemComponent } from './menu-item.component'
import { SeMenuReferenceComponent } from './menu-reference.component'
import { SeIconModule } from './../icon/icon.module'

@NgModule({
  imports: [
	CommonModule, 
    RouterModule,
    SeIconModule
  ],
  declarations: [
    SeMenuComponent,
    SeMenuItemComponent,
    SeMenuReferenceComponent,
  ],
  providers: [
    SeMenuService,
  ],
  exports: [
    SeMenuComponent,
    SeMenuItemComponent,
    SeMenuReferenceComponent
  ]
})
export class SeMenuModule {}

export const SE_MENU_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.menu`

